import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {
    httpGetSignatureSheets,
    HttpGetSignatureSheetsOptions,
    HttpGetSignatureSheetsResponse
} from '@/features/accesses/http/accesses.http'

export const useGetSignatureSheets = (
    params: HttpGetSignatureSheetsOptions['params'],
    options?: Omit<UseQueryOptions<HttpGetSignatureSheetsResponse>, 'queryKey' | 'queryFn'>
) => {
    return useQuery({
        queryKey: [QUERY_KEYS.ACCESSES, QUERY_KEYS.ACCESSES_SIGNATURE_SHEETS, params],
        queryFn: () => httpGetSignatureSheets({params}),
        ...options
    })
}
